import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseLinks = ({ platformUrl }) => {
    const [links, setLinks] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please log in.");
            setLoading(false);
            return;
        }

        const fetchAllContentItems = async (courseId, parentId = "ROOT") => {
            const contents = [];
            const stack = [parentId];

            while (stack.length > 0) {
                const currentParentId = stack.pop();

                try {
                    const response = await axios.get(
                        `${platformUrl}/learn/api/public/v1/courses/${courseId}/contents?parentId=${currentParentId}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );

                    for (const item of response.data.results) {
                        contents.push(item);

                        if (item.hasChildren) {
                            stack.push(item.id);
                        }
                    }
                } catch (err) {
                    console.warn(`Error fetching contents for course ${courseId}:`, err.message);
                }
            }

            return contents;
        };

        const fetchCourseLinks = async () => {
            try {
                // Resolve UUID → courseId
                const courseRes = await axios.get(
                    `${platformUrl}/learn/api/public/v3/courses/uuid:${courseUuid}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const courseId = courseRes.data.id;

                const allContent = await fetchAllContentItems(courseId);

                const htmlLinks = allContent.filter(
                    (item) => item.contentHandler?.id === "resource/x-bb-externallink"
                );

                setLinks(htmlLinks);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCourseLinks();
    }, [platformUrl, token, courseUuid]);

    if (loading) {
        return <div>Loading HTML links…</div>;
    }

    if (error) {
        return (
            <div className="bb-container bb-error">
                <h1 className="bb-title">Error</h1>
                <p>{error}</p>
                <p>Please check your access token or course UUID and try again.</p>
            </div>
        );
    }

    if (links.length === 0) {
        return <div>No HTML links found in this course.</div>;
    }

    return (
        <div className="bb-container">
            <h1 className="bb-title">HTML Links in Course</h1>
            <ul>
                {links.map((link) => (
                    <li key={link.id}>
                        <a
                            href={link.contentHandler?.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {link.title || "Untitled Link"}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CourseLinks;
